import React, { createContext, useContext } from 'react';

export const AnalyticsContext = createContext(undefined);

export const SegmentAnalyticsProvider = ({ children, analytics }) => {
	return (
		<AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>
	);
};

export const useAnalytics = () => {
	const result = useContext(AnalyticsContext);
	if (!result) {
		throw new Error('Context used outside of its Provider!');
	}
	return result;
};
